import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface EntityType {
  id: string;
  name: string;
  label: string;
  color: string;
  is_active: boolean;
}

export const useEntityTypes = () => {
  const { data: entityTypes, isLoading, refetch } = useQuery({
    queryKey: ["entity-types"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("entity_types")
        .select("*")
        .eq("is_active", true)
        .order("label");
      
      if (error) throw error;
      return data as EntityType[];
    },
  });

  return { 
    entityTypes: entityTypes || [], 
    isLoading,
    refetch 
  };
};
